// Real resume projects for Yash Punmiya
export const PROJECTS = [
  {
    title: "FlowVault",
    date: "2025",
    category: "Web3 & DeFi",
    stack: ["Stacks", "Clarity", "Next.js"],
    subtext: "Programmable stablecoin vault on Stacks. Won Stacks USDCx Challenge ($3,000) & $10k Stacks Foundation Grant for automated fund routing.",
    url: "https://github.com/yashpunmiya",
  },
  {
    title: "PredictFi",
    date: "2025",
    category: "DeFi / Solana",
    stack: ["Solana", "Anchor", "Next.js"],
    subtext: "Decentralized prediction market platform on Solana featuring live market data, AMM-based pricing, on-chain payouts & leaderboards.",
    url: "https://github.com/yashpunmiya",
  },
  {
    title: "CoalSafe",
    date: "2024",
    category: "Blockchain & IoT",
    stack: ["Blockchain", "IoT", "OpenCV"],
    subtext: "Blockchain & IoT security system preventing coal theft with machine learning and OpenCV anomaly detection. Winner Codeutsava 8.0.",
    url: "https://github.com/yashpunmiya",
  },
  {
    title: "FinVoice",
    date: "2025",
    category: "Gen-AI & FinTech",
    stack: ["Gen-AI", "React", "Node.js"],
    subtext: "AI-powered financial tracking software connecting banks, cards & financial apps. Grand Winner of Sunhacks 2025 Gen-AI Hackathon.",
    url: "https://github.com/yashpunmiya",
  },
  {
    title: "FairDrop",
    date: "2025",
    category: "Web3 & Privacy",
    stack: ["HashKey", "ZK-ID", "Solidity"],
    subtext: "Privacy-preserving token distribution platform leveraging zero-knowledge identity verification on HashKey Chain. ZK-ID Track Winner.",
    url: "https://github.com/yashpunmiya",
  },
  {
    title: "GamifiED",
    date: "2025",
    category: "Ed-Tech & AI",
    stack: ["React", "AI/ML", "Node.js"],
    subtext: "Interactive ed-tech platform gamifying learning with Snake & Ladder, Bingo, Spin Wheel, and AI-generated questions.",
    url: "https://github.com/yashpunmiya",
  },
  {
    title: "MentorConnect",
    date: "2024",
    category: "Full-Stack AI",
    stack: ["React", "Python", "RAG AI"],
    subtext: "Full-stack mentoring platform with RAG-powered AI assistant and analytics dashboards currently serving 300+ students at Fr. CRCE.",
    url: "https://github.com/yashpunmiya",
  },
  {
    title: "UAE Jain Pooja Platform",
    date: "2024",
    category: "Full-Stack Web",
    stack: ["Next.js", "Supabase", "QR Engine"],
    subtext: "Official online Pooja booking platform for the UAE Jain community featuring slot management, real-time availability & QR confirmations.",
    url: "https://github.com/yashpunmiya",
  }
];

export const ACHIEVEMENTS = [
  {
    title: "Smart India Hackathon 2025",
    role: "National Winner",
    category: "Web 2.0 / Defense Systems",
    desc: "Developed a self-healing FPGA architecture using Triple Modular Redundancy (TMR) for autonomous glitch detection in defense systems.",
    highlight: "1st Place Winner"
  },
  {
    title: "Sunhacks 2025",
    role: "Grand Winner",
    category: "Asia's Largest Gen-AI Hackathon",
    desc: "Secured 1st prize beating 550+ offline teams & 4000+ innovators by building FinVoice financial tracking software.",
    highlight: "Asia Book of Records"
  },
  {
    title: "Codeutsava 8.0 (NIT Raipur)",
    role: "Overall Winner",
    category: "Central India's Largest Hackathon",
    desc: "Secured 1st place among 1000+ teams for building CoalSafe (Blockchain, OpenCV, IoT). Featured in Dainik Bhaskar newspaper.",
    highlight: "1st / 1000+ Teams"
  },
  {
    title: "Stacks USDCx Builder Challenge",
    role: "Winner & Grant Awardee",
    category: "Web 3.0 / Stacks Blockchain",
    desc: "Won 1st place ($3,000) for FlowVault and secured a $10,000 Stacks Foundation Grant for continued protocol development.",
    highlight: "$13,000 Awarded"
  },
  {
    title: "HashKey Chain Horizon Hackathon",
    role: "ZKID Track Winner",
    category: "Web 3.0 / Privacy ZK",
    desc: "Won 1st Place for FairDrop, a privacy-preserving token distribution platform with zero-knowledge identity verification.",
    highlight: "1st Place ZK Track"
  },
  {
    title: "Recursion 6.0 & Quasar 3.0",
    role: "National Winner",
    category: "National Level Hackathons",
    desc: "Won 1st place at RGIT Andheri for BankFlow financial tracking software, and Quasar 3.0 for AI mentoring platform.",
    highlight: "Double Victory"
  }
];

export const SKILLS = [
  {
    category: "Frontend & Creative",
    skills: ["React.js", "Next.js", "JavaScript (ES6+)", "HTML5 / CSS3", "GSAP Animations", "Three.js / R3F", "Styled Components", "Tailwind CSS"]
  },
  {
    category: "Backend & Cloud",
    skills: ["Python", "Django", "Node.js", "Express", "PostgreSQL", "Supabase", "Firebase", "REST APIs", "AWS", "Docker"]
  },
  {
    category: "Web3 & Languages",
    skills: ["Solidity", "Clarity (Stacks)", "Anchor (Solana)", "C", "C++", "Git & GitHub", "OpenCV", "Machine Learning"]
  }
];

export const EXPERIENCE = [
  {
    role: "Founder & Lead Developer",
    company: "4iStudios",
    period: "July 2025 — Present",
    desc: "Founded an AI and software development studio delivering custom web apps, SaaS products, and automation solutions. Generated ₹6L+ in sales within the first 3 months, leading end-to-end product development and client relations."
  }
];

export const EDUCATION = [
  {
    degree: "B.E. in Computer Engineering",
    institution: "Fr. Conceicao Rodrigues College of Engineering (Bandra W)",
    period: "Final Year Student",
    stats: "CGPA: 8.90 (3rd Yr) | 8.92 (2nd Yr) | 8.53 (1st Yr)",
    extra: "JEE Main: 96.35 Percentile"
  }
];
